import React from 'react';
import { Card } from './Card';

function isCard(node) {
  return React.isValidElement(node) && node.type === Card;
}

// Marker invece di identity-check, così `helpers` non importa
// `CardsColumnContainer` (rompe il ciclo helpers ↔ CardsColumnContainer).
function isCardsColumnContainer(node) {
  return React.isValidElement(node) && node.type?.isCardsColumnContainer === true;
}

function clampCols(n) {
  if (typeof n !== 'number' || !isFinite(n)) return undefined;
  return Math.max(1, Math.min(12, Math.floor(n)));
}

function makeColClass(bpCols) {
  const parts = [
    `col-12${bpCols.base ? ` col-${Math.floor(12 / bpCols.base)}` : ''}`,
    bpCols.sm ? `col-sm-${Math.floor(12 / bpCols.sm)}` : '',
    bpCols.md ? `col-md-${Math.floor(12 / bpCols.md)}` : '',
    bpCols.lg ? `col-lg-${Math.floor(12 / bpCols.lg)}` : '',
    bpCols.xl ? `col-xl-${Math.floor(12 / bpCols.xl)}` : '',
  ];
  return parts.filter(Boolean).join(' ');
}

export { isCard, isCardsColumnContainer, clampCols, makeColClass };
